import { createStore } from 'vuex'

import Auth from './auth/auth'
import AuthVendor from './auth/vendor'
import BusinessUnit from './business_unit/business_unit'

import User from './user/user'
import SuperAdmin from './admin/super_admin'
import BusinessUnitAdmin from './admin/business_unit_admin'
import BusinessUnitUser from './admin/business_unit_user'
import BusinessUnitUserEmail from './admin/business_unit_user_email'
import Role from './role/role'
import Position from './admin/position'
import Designation from './admin/designation'
import Module from './role/module'

// System Settings
import Site from './system_settings/site'
import Bank from './system_settings/bank'
import CheckStatus from './system_settings/check_status'
import IbpsStatus from './system_settings/ibps_status'
import PaymentPortalStatus from './system_settings/payment_portal_status'
import PaymentStatusEvent from './system_settings/payment_status_event'
import PaymentStatusUpdater from './system_settings/payment_status_updater'
import PaymentStatusMapping from './system_settings/payment_status_mapping'
import PaymentMethod from './system_settings/payment_method'
import SmsTemplate from './system_settings/sms_template'
import EmailTemplate from './system_settings/email_template'
import NotificationGroup from './system_settings/notification_group'
import SmsRecipient from './system_settings/sms_recipient'
import EmailRecipient from './system_settings/email_recipient'

// Payment Management
import AdminOrEndUserEntryInventory from './payment_management/invoice/invoice'

import AuditLog from './system_settings/audit_log'
import PassthruLaravelLog from './log/passthru_log'
import AuthLaravelLog from './log/auth_log'
import EmailLaravelLog from './log/email_log'
import SMSLaravelLog from './log/sms_log'
import CronLaravelLog from './log/cron_log'
import VendorLaravelLog from './log/vendor_log'
import EmployeeLaravelLog from './log/employee_log'
import LaravelLog from './log/log'
import EmailReport from './system_settings/transaction_log/email_report'
import SMSReport from './system_settings/transaction_log/sms_report'

import ApText from './ibps/ap_t_ext'
import ApTsla from './ibps/ap_t_sla'
import ApTcommentHistory from './ibps/ap_t_comment_history'
import ApTcmplxPo from './ibps/ap_t_cmplx_po'
import TravelText from './ibps/travel_t_ext'
import TravelTsla from './ibps/travel_t_sla'
import PcText from './ibps/pc_t_ext'
import PcTsla from './ibps/pc_t_sla'

// DATA
// DATA - IBPS 
import AP from './data/ibps/ap'
import IRR from './data/ibps/irr'
import PCRF from './data/ibps/pcrf'
import PONUM from './data/ibps/ponum'
import TCE from './data/ibps/tce'
// DATA - TREASURY 
import CoalPayment from './data/treasury/coal_payment'

import Vendor from './vendor/vendor'
import VendorApi from './vendor/vendor-api'
import VendorInvoice from './vendor/invoice'
import InvoiceFile from './vendor/invoice_file'
import InvoiceFileAdmin from './vendor/invoice_file_admin'
import PaymentStatusPortal from './vendor/payment_status_portal'
import EndUser from './vendor/end_user'
import InvoiceQueryAdmin from './vendor/invoice_query_admin'
import InvoiceQueryVendor from './vendor/invoice_query_vendor'
import VendorApCommentHistory from './vendor/ap_t_comment_history'

import EmployeeInvoice from './employee_payment_portal/employee_invoice'

import Option from './option/option'
import Dashboard from './dashboard/payment_status_portal'
import Notification from './notification/notification'
import NotificationVendor from './notification/notification_vendor'

export default createStore({
    modules: {
        Auth,
        AuthVendor,
        User,
        SuperAdmin,
        BusinessUnitAdmin,
        BusinessUnitUser,
        BusinessUnitUserEmail,
        Role,
        Position,
        Designation,
        BusinessUnit,

        // system settings
        Site,
        Bank,
        CheckStatus,
        IbpsStatus,
        PaymentPortalStatus,
        PaymentStatusEvent,
        PaymentStatusUpdater,
        PaymentStatusMapping,
        PaymentMethod,
        AuditLog,
        EmailReport,
        SMSReport,
        SmsTemplate,
        EmailTemplate,
        NotificationGroup,
        SmsRecipient,
        EmailRecipient,
        LaravelLog,
        PassthruLaravelLog,
        AuthLaravelLog,
        EmailLaravelLog,
        SMSLaravelLog,
        CronLaravelLog,
        VendorLaravelLog,
        EmployeeLaravelLog,

        // payment management
        AdminOrEndUserEntryInventory,

        ApText,
        ApTsla,
        ApTcommentHistory,
        ApTcmplxPo,
        TravelText,
        TravelTsla,
        PcText,
        PcTsla,

        // DATA
        // DATA - IBPS
        AP,
        IRR,
        PCRF,
        PONUM,
        TCE,
        // DATA - TREASURY
        CoalPayment,

        Vendor,
        VendorApi,
        VendorInvoice,
        InvoiceFile,
        InvoiceFileAdmin,
        PaymentStatusPortal,
        EndUser,
        InvoiceQueryAdmin,
        InvoiceQueryVendor,
        VendorApCommentHistory,

        EmployeeInvoice,

        Module,
        Option,
        Dashboard,
        Notification,
        NotificationVendor
    }
})
